import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import PricingSubpageSection1 from "../../components/Pricing/PricingSubpageSection1/PricingSubpageSection1";
import CoreVirtuesValues from "../../components/CoreVirtuesValues/CoreVirtuesValues";
import Footer from "../../components/Footer/Footer";
import { useTranslation } from "react-i18next";
const CreativeDesing = () => {
  const { t } = useTranslation("global");

  const basicPlanFeatures = [
    t("creative.basicFeature1"),
    t("creative.basicFeature2"),
    t("creative.basicFeature3"),
  ];

  const standardPlanFeatures = [
    t("creative.standardFeature1"),
    t("creative.standardFeature2"),
    t("creative.standardFeature3"),
    t("creative.standardFeature4"),
  ];

  const enterprisePlanFeatures = [
    t("creative.enterpriseFeature1"),
    t("creative.enterpriseFeature2"),
    t("creative.enterpriseFeature3"),
  ];

  return (
    <>
      <Navbar />
      <PricingSubpageSection1
        mainTitle={t("creative.mainTitle")}
        subtitleText={t("creative.subtitleText")}
        basicPlanTitle={t("creative.basicPlanTitle")}
        basicPlanDescription={t("creative.basicPlanDescription")}
        basicPlanFeatures={basicPlanFeatures}
        standardPlanTitle={t("creative.standardPlanTitle")}
        standardPlanDescription={t("creative.standardPlanDescription")}
        standardPlanFeatures={standardPlanFeatures}
        enterprisePlanTitle={t("creative.enterprisePlanTitle")}
        enterprisePlanDescription={t("creative.enterprisePlanDescription")}
        enterprisePlanFeatures={enterprisePlanFeatures}
      />
      <CoreVirtuesValues />
      <Footer />
    </>
  );
};

export default CreativeDesing;
